import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { GenderEnum } from '@isophi/mng-api';

@Component({
  selector: 'app-group-detail-card',
  templateUrl: './group-detail-card.component.html',
  styleUrls: ['./group-detail-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GroupDetailCardComponent {
  // Types: ChildGroupProfile || ChildAttendance
  @Input() child: any;

  @Input() isChildMarked: boolean;

  @Input() disabled: boolean;

  /** Shows "return" button instead of checkbox */
  @Input() returnable = false;

  // Types: ChildGroupProfile || ChildAttendance
  @Output() childClick = new EventEmitter<any>();

  @Output() returnClick = new EventEmitter<any>();

  genderEnum = GenderEnum;

  onClick(e: Event) {
    if (this.disabled) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      this.childClick.emit(this.child);
      this.isChildMarked = !this.isChildMarked;
    }
  }

  onReturnClick(e: Event): void {
    e.stopPropagation();
    this.returnClick.emit(this.child);
  }
}
